'use strict';
let ajaxTimeout = null;

/*global bootstrap*/

/* ========================================================================
 * starts with
 * ========================================================================*/
if (typeof String.prototype.startsWith !== 'function') {
    String.prototype.startsWith = function (str) {
        if (str === null) return false;
        let i = str.length;
        if (this.length < i) {
            return false;
        }

        for (--i; (i >= 0) && (this[i] === str[i]); --i) {
            return i < 0;
        }
    }
}

/* ========================================================================
 * clear the error feedback for input and select controls
 * ========================================================================*/
function clearErrorsOnChange() {
    $('input').change(function () {
        let $this = $(this);

        if (!$this.hasClass("password-meter") && !$this.hasClass("password-repeat")) {
            $this.removeClass('is-invalid');
        }
    });

    $('select').change(function () {
        let $this = $(this);

        if ($this.hasClass("date")) {
            $this.parent().parent().parent().find('.is-invalid').removeClass('is-invalid');
        } else if ($this.hasClass("devolo-select")) {
            $this.parents('.bootstrap-select').removeClass('is-invalid');
        } else {
            $this.removeClass('is-invalid');
        }
    });
}

/* ========================================================================
 * Init external links
 * ========================================================================*/
function initExternalLinks() {
    $('a.external').each(function () {
        $(this)
            .attr("target", "_blank")
            .attr("rel", "noopener");
    })
}

/* ========================================================================
 * Init checkbox
 * ========================================================================*/
function initCheckBox() {
    let $checkboxInput = $('.input-checkbox input');
    let $checkboxDisabled = $checkboxInput.prop('disabled');

    $('.input-checkbox .checkbox_icon').click(function () {
        if ($checkboxDisabled) {
            return;
        }
        let $this = $(this);
        $this.removeClass('is-invalid');
        $this.parents('.devolo_checkbox').removeClass('is-invalid');

        if ($this.hasClass('checkbox_on')) {
            $this.removeClass('checkbox_on').parent().parent().prev('input').prop('checked', false).focus();
        } else {
            $this.addClass('checkbox_on').parent().parent().prev('input').prop('checked', true).focus();
        }
    });

    $checkboxInput.each(function () {
        let checkBoxIcon = $(this).parent().find('.checkbox_icon');
        if ($(this).prop('checked')) {
            checkBoxIcon.addClass('checkbox_on');
        }
        if ($checkboxDisabled) {
            checkBoxIcon.css('cursor', 'not-allowed');
        }
    }).click(function (e) {
        e.preventDefault();
        if ($checkboxDisabled) {
            return;
        }
        $(this).prop('checked', !$(this).prop('checked'));
    }).keyup(function (e) {
        if (e.keyCode === 32 && !$checkboxDisabled) {
            e.preventDefault();
            $(this).parent().find('.checkbox_icon').trigger('click');
        }
    }).focus(function () {
        $(this).parent().find('.checkbox_icon').addClass('input-focus');
    }).focusout(function () {
        $(this).parent().find('.checkbox_icon').removeClass('input-focus');
    });
}

/* ========================================================================
 * Init switch checkbox
 * ========================================================================*/
function initSwitchCheckBox() {
    $('.switch-checkbox').focus(function () {
        $(this).next('.switch-label').addClass('input-focus');
    }).focusout(function () {
        $(this).next('.switch-label').removeClass('input-focus');
    });
}

/* ========================================================================
 * init select
 * ========================================================================*/
function changeSelectHandler() {
    let $select = $(this);
    if ($select.val()) {
        $select.next('.btn-group').children('.btn').removeClass('input-placeholder');
    } else {
        $select.next('.btn-group').children('.btn').addClass('input-placeholder');
    }
}

function changeContextSearchHandler() {
    let $this = $(this);
    let timerId = $this.attr('data-timer');
    if (timerId) {
        clearTimeout(timerId);
        $this.attr('data-timer', null);
    }

    $this.attr('data-timer', setTimeout(function () {
        $this.val('');
        $this.trigger('propertychange')
    }, 2000));
}

function initSelect() {
    let liveSearch = true;
    if ($.browser.mobile === true) {
        liveSearch = false;
    }

    let $selectpicker = $('.devolo-select').selectpicker({
        dropupAuto: false,
        selectOnTab: true,
        liveSearch: liveSearch,
        style: 'input-bg'
    });

    $(document).off('change', '.devolo-select', changeSelectHandler);
    $(document).on('change', '.devolo-select', changeSelectHandler);
    $selectpicker.trigger('change');

    $(document).off('change', '.bootstrap-select .bs-searchbox input', changeContextSearchHandler);
    $(document).on('change', '.bootstrap-select .bs-searchbox input', changeContextSearchHandler);
}

/* ========================================================================
 * init day select
 * ========================================================================*/
function initDateSelect() {
    $('.date-select').each(function () {
        let $select = $(this);

        let date = $select.val();
        if (date) {
            let dateParts = date.split("-");
            if (dateParts.length === 3) {
                let $parent = $select.parent();
                $parent.find('select.day').selectpicker('val', dateParts[2]).trigger('change');
                $parent.find('select.month').selectpicker('val', dateParts[1]).trigger('change');
                $parent.find('select.year').selectpicker('val', dateParts[0]).trigger('change');
            }
        }
    });
}

/* ========================================================================
 * init date change
 * ========================================================================*/
function initDateChange() {
    $('select.date').change(function () {
        let $parent = $(this).parent().parent().parent();
        let day = $parent.find('select.day').val();
        let month = $parent.find('select.month').val();
        let year = $parent.find('select.year').val();
        if (day && month && year) {
            $parent.find('input.date-select').val(year + '-' + month + '-' + day);
        } else {
            $parent.find('input.date-select').val('');
        }
    });
}

/* ========================================================================
 * init the password strength bar
 * ========================================================================*/
function initPasswordStrengthBar() {
    $('.password-meter').each(function () {
        let $this = $(this);
        $this.parent().after('<div id="pwd-strength-meter" style="display: none;"><div class="pwd-strength"><div class="pwd-strength-bar"></div></div><p class="pwd-strength-text"><span class="text"></span><span class="hint">' + $this.parents('.password-box').data('hint') + '</span></span></p></div>');

        let $passwordBox = $this.parents('.password-box');
        $passwordBox.find('.hint-text').hide().addClass('invalid-feedback');
        $passwordBox.find('.hint-text-1').removeClass('invalid-feedback').addClass('valid-feedback');

        $this.keyup(function () {
            if (ajaxTimeout) {
                clearTimeout(ajaxTimeout);
                ajaxTimeout = null;
            }

            let password = $this.val();
            let email = $('#email').val();
            if (password.length !== 0) {
                let $passwordRepeat = $passwordBox.find('.password-repeat');
                let csrf = $('input[name=_csrf]').val();
                ajaxTimeout = setTimeout(function () {
                    $.ajax({
                        type: 'POST',
                        url: messages.context_path + '/password_score',
                        data: {'password': password, 'email': email, '_csrf': csrf},
                        dataType: 'json'
                    }).fail(function (msg) {
                        console.log(msg);
                    })
                        .done(function (msg) {
                            let $pwdStrengthMeter = $('#pwd-strength-meter');
                            $pwdStrengthMeter.find('.pwd-strength-text .text').text(msg.text);
                            $pwdStrengthMeter.find('.pwd-strength-bar').removeClass().addClass('pwd-strength-bar')
                                .addClass(msg.grade).css('width', msg.score + '%');
                            $passwordRepeat.trigger('keyup');
                        });
                }, 250);
            }
        });


        $this.focusin(function () {
            $(this).trigger('keyup');
            $('#pwd-strength-meter').show();
        });

        if ($('.admin-edit-user').length === 0) {
            $this.focusout(function () {
                $('#pwd-strength-meter').hide();
            });
        }
    });

    $('.password-repeat').keyup(function () {
        let $this = $(this);
        let $passwordBox = $this.parents('.password-box');
        let $plainPassword = $('#plainPassword');
        let $plainPasswordRepeat = $('#plainPasswordRepeat');
        let password = $passwordBox.find('.password-meter').val();

        $plainPassword.removeClass('is-invalid');
        $plainPasswordRepeat.removeClass('is-invalid');

        if (password.length === 0) {
            $this.siblings('.hint-text-1').hide();
            $this.siblings('.hint-text-2').hide();
            $this.siblings('.hint-text-3').hide();
            $this.siblings('.hint-text-4').hide();
            $this.siblings('.hint-text-5').hide();
        } else if ($('.password-repeat').parents('.password-box').find('.pwd-strength-bar').hasClass('weak')) {
            $plainPassword.addClass('is-invalid');
            $plainPasswordRepeat.addClass('is-invalid');

            $this.siblings('.hint-text-1').hide();
            $this.siblings('.hint-text-2').hide();
            $this.siblings('.hint-text-3').show();
            $this.siblings('.hint-text-4').hide();
            $this.siblings('.hint-text-5').hide();
        } else if ($('.password-repeat').parents('.password-box').find('.pwd-strength-bar').hasClass('blacklisted')) {
            $plainPassword.addClass('is-invalid');
            $plainPasswordRepeat.addClass('is-invalid');

            $this.siblings('.hint-text-1').hide();
            $this.siblings('.hint-text-2').hide();
            $this.siblings('.hint-text-3').hide();
            $this.siblings('.hint-text-4').show();
            $this.siblings('.hint-text-5').hide();
        } else if ($('.password-repeat').parents('.password-box').find('.pwd-strength-bar').hasClass('username_matches')) {
            $plainPassword.addClass('is-invalid');
            $plainPasswordRepeat.addClass('is-invalid');

            $this.siblings('.hint-text-1').hide();
            $this.siblings('.hint-text-2').hide();
            $this.siblings('.hint-text-3').hide();
            $this.siblings('.hint-text-4').hide();
            $this.siblings('.hint-text-5').show();
        } else {
            let passwordRepeat = $this.val();
            if (password && passwordRepeat && passwordRepeat.length !== 0) {
                if (password === passwordRepeat) {
                    $this.siblings('.hint-text-2').hide();
                    $this.siblings('.hint-text-3').hide();
                    $this.siblings('.hint-text-4').hide();
                    $this.siblings('.hint-text-5').hide();
                    $this.siblings('.hint-text-1').fadeIn();
                } else {
                    $plainPassword.addClass('is-invalid');
                    $plainPasswordRepeat.addClass('is-invalid');

                    $this.siblings('.hint-text-1').hide();
                    $this.siblings('.hint-text-3').hide();
                    $this.siblings('.hint-text-4').hide();
                    $this.siblings('.hint-text-5').hide();
                    $this.siblings('.hint-text-2').fadeIn();
                }
            } else {
                $this.siblings('.hint-text-1').hide();
                $this.siblings('.hint-text-2').hide();
                $this.siblings('.hint-text-3').hide();
                $this.siblings('.hint-text-4').hide();
                $this.siblings('.hint-text-5').hide();
            }
        }
    });
}

/* ========================================================================
 * add ajax overlay
 * ========================================================================*/
function addAjaxOverlay() {
    $('body').append('<div id="ajax-overlay"></div><div id="ajax-loader"><img src="' + messages.raw_context_path + '/resources/images/devolo-loader.gif" alt=""/></div>');
}

/* ========================================================================
 * remove ajax overlay
 * ========================================================================*/
function removeAjaxOverlay() {
    setTimeout(function () {
        $('#ajax-loader').fadeOut();
        $('#ajax-overlay').fadeOut(function () {
            $('#ajax-loader').remove();
            $('#ajax-overlay').remove();
        });
    }, 1000);
}

/* ========================================================================
 * init loader submit
 * ========================================================================*/
function initLoaderSubmit() {
    $(':button[type="submit"].btn-loader').click(function (e) {
        e.preventDefault();
        addAjaxOverlay();
        setTimeout(function () {
            $("form:first").submit();
        }, 1000);

    });
}

/* ========================================================================
 * init action delete
 * ========================================================================*/
function postAction($form, action) {
    $form.attr('action', action);
    $form.submit();
}

function initActionDelete() {
    $('a.action-delete').click(function (e) {
        e.preventDefault();
        let $anchor = $(this);
        if ($anchor.hasClass('disabled')) {
            return;
        }

        let dialogId = $anchor.attr('data-dialog');
        let action = $anchor.attr('data-method');

        if (dialogId) {
            let $confirmDialog = $('#' + dialogId);
            $confirmDialog.find('.btn-modal-confirm').click(function (e) {
                e.preventDefault();
                if ($anchor.attr('href') === '#') {
                    return;
                }

                if (action === "get") {
                    window.location = $anchor.attr('href');
                } else {
                    postAction($('form.action-delete'), $anchor.attr('href'));
                }
            });

            let bsConfirmDialog = new bootstrap.Modal($confirmDialog.get(0), {
                keyboard: true
            });
            bsConfirmDialog.show();

        } else {
            if ($anchor.attr('href') === '#') {
                return;
            }

            if (action === "get") {
                window.location = $anchor.attr('href');
            } else {
                postAction($('form.action-delete'), $anchor.attr('href'));
            }
        }
    });
}

/* ========================================================================
 * init flyout
 * ========================================================================*/
function initFlyout() {
    let $flyout = $('#flyout');
    let $flyoutMenu = $('#flyout-menu');
    let $flyoutAction = $('#button-flyout');

    $flyoutAction.on('click', function (e) {
        e.preventDefault();
        if ($flyout.hasClass('visible')) {
            $flyout.fadeOut(700);
        } else {
            $flyout.fadeIn(700);

        }
        $flyout.toggleClass('visible');
    });

    $flyoutMenu.mouseleave(function () {
        $flyout.removeClass('visible');
        $flyout.fadeOut(700);
    });
}

/* ========================================================================
 * init user address form
 * ========================================================================*/
function initUserAddressForm() {
    if ($('.form-add-address').length > 0 || $('.form-edit-address').length > 0) {
        $('#country').change(function () {
            let countryCode = $('#country').selectpicker('val');
            let $timezone = $('#timezone');
            $timezone.find('option:not(:first)').remove();
            if (countryCode.length <= 0) {
                countryCode = 'ZZ';
            }
            $.ajax({
                type: 'GET',
                url: messages.context_path + '/timezones/' + countryCode,
                dataType: 'json'
            }).fail(function (msg) {
                console.log(msg);
            }).done(function (msg) {
                $.each(msg.timezones, function (i, item) {
                    $timezone.append($("<option></option>").attr("value", item.id).text(item.name));
                });
                $timezone.selectpicker('refresh');
            });
        });
    }
}

/* ========================================================================
 * init dcloud setting cookie
 * ========================================================================*/
function initCookie() {
    if ($.cookie('dc_settings') === undefined) {
        return $.cookie('dc_settings', {hcGatewaySlider: 1}, {
            expires: 30,
            path: '/',
            secure: ("https:" === document.location.protocol)
        });
    }
}

/* ========================================================================
 * get the hc gateway slider position
 * ========================================================================*/
function getHcGatewaySliderPosition() { // eslint-disable-line no-unused-vars
    $.cookie.json = true;
    let $cookie = $.cookie('dc_settings');
    if ($cookie === undefined) {
        return 1;
    }
    return $('.slider-item[data-hc_gateway="' + $cookie.hcGatewaySlider + '"]').attr('data-hc_gateways-pos');
}

/* ========================================================================
 * update the hc gateway slider position
 * ========================================================================*/
function updateHcGatewaySliderPosition(position) { // eslint-disable-line no-unused-vars
    $.cookie.json = true;
    let $cookie = $.cookie('dc_settings');
    if ($.cookie('dc_settings') === undefined) {
        initCookie();
        $cookie = $.cookie('dc_settings');
    }

    if ($cookie !== undefined) {
        $cookie.hcGatewaySlider = $('.slider-item[data-hc_gateways-pos="' + position + '"]').data('hc_gateway');
        $.cookie('dc_settings', $cookie, {expires: 7, path: '/', secure: ("https:" === document.location.protocol)});
    }
}

/* ========================================================================
 * init the simple slider
 * ========================================================================*/
function initSimpleSlider() {
    $('.simple-slider-input')
        .show()
        .keydown(function (e) {
            if (e.keyCode === 37) {
                e.preventDefault();
                let $slider1 = $('.simple-slider-input');
                let data1 = $slider1.attr('data-slider-values').split(',');
                let pos1 = $.inArray($slider1.val(), data1);
                if (pos1 > 0) {
                    $slider1.simpleSlider('setValue', data1[pos1 - 1]);
                }
            } else if (e.keyCode === 39) {
                e.preventDefault();
                let $slider2 = $('.simple-slider-input');
                let data2 = $slider2.attr('data-slider-values').split(',');
                let pos2 = $.inArray($slider2.val(), data2);
                if (pos2 < data2.length - 1) {
                    $slider2.simpleSlider('setValue', data2[pos2 + 1]);
                }
            }
        })
        .focus(function () {
            $(this).parent().find('.track').addClass('input-focus');
        }).focusout(function () {
        $(this).parent().find('.track').removeClass('input-focus');
    });
}

/* ========================================================================
 * init language select
 * ========================================================================*/
function initLanguageSelect() {
    let $languageSwitch = $('#language-switch');
    let $languageSelect = $('#language-select');
    $languageSwitch.click(function (e) {
        e.preventDefault();
        if ($languageSelect.hasClass('visible')) {
            $languageSelect.fadeOut(700);
        } else {
            $languageSelect.fadeIn(700);
        }
        $languageSelect.toggleClass('visible');
    });

    $languageSelect.mouseleave(function () {
        $languageSelect.removeClass('visible');
        $languageSelect.fadeOut(700);
    });
}

/* ========================================================================
 * initDashboardEditForm
 * ========================================================================*/
function initDashboardEditForm() {
    if ($('.dashboard.edit-mode').length > 0) {
        $('.btn-toggle-action').each(function () {
            let $this = $(this);
            let action = $this.attr('data-action');
            if ($('#show' + action).prop('checked') === true) {
                $this.parents('.btn-action').removeClass('btn-action-inactive');
                $this.attr('title', $this.attr('data-remove'));
                $this.children('.btn-sm-img').removeClass().addClass('btn-sm-img').addClass('btn-sm-remove-item');
            } else {
                $this.parents('.btn-action').addClass('btn-action-inactive');
                $this.attr('title', $this.attr('data-add'));
                $this.children('.btn-sm-img').removeClass().addClass('btn-sm-img').addClass('btn-sm-add-item');
            }
        }).click(function (e) {
            e.preventDefault();
            let $this = $(this);
            let action = $this.attr('data-action');
            let $checkbox = $('#show' + action);
            if ($checkbox.prop('checked') === true) {
                $checkbox.prop('checked', false);
                $this.parents('.btn-action').addClass('btn-action-inactive');
                $this.attr('title', $this.attr('data-add'));
                $this.children('.btn-sm-img').removeClass().addClass('btn-sm-img').addClass('btn-sm-add-item');
            } else {
                $checkbox.prop('checked', true);
                $this.parents('.btn-action').removeClass('btn-action-inactive');
                $this.attr('title', $this.attr('data-remove'));
                $this.children('.btn-sm-img').removeClass().addClass('btn-sm-img').addClass('btn-sm-remove-item');
            }
        });
    }
}

/* ========================================================================
 * initHcGatewayEditForm
 * ========================================================================*/
function initHcGatewayEditForm() {
    if ($('.edit-hc_gateway').length > 0) {
        let $editAddress = $('#edit-address');
        $editAddress.click(function (e) {
            e.preventDefault();
            let $selectAddressDialog = $('#select-address-dialog');
            $selectAddressDialog.load(messages.context_path + '/hc/gateways/' + $selectAddressDialog.attr('data-hcgateway') + '/edit_select_address', function () {
                let $selectAddress = $('#select-address');
                let bsSelectAddress = new bootstrap.Modal($selectAddress.get(0), {
                    keyboard: true
                });
                bsSelectAddress.show();

                $selectAddress.find('.btn-use-address').click(function (e) {
                    e.preventDefault();
                    postAction($('form.edit-address'), $(this).attr('href'));
                });
            });
        });

        if ($('#select-address-dialog').hasClass('autoshow')) {
            $editAddress.trigger('click');
        }

        $('#add-gateway-user').click(function (e) {
            e.preventDefault();
            let $inviteUserDialog = $('#invite-user-dialog');
            let inviteUrl = messages.context_path + '/hc/gateways/' + $inviteUserDialog.attr('data-hcgateway') + '/invite';
            let editHcGateway = messages.context_path + '/hc/gateways/' + $inviteUserDialog.attr('data-hcgateway') + '/edit';
            $inviteUserDialog.load(inviteUrl, function () {
                let $inviteUser = $('#invite-user');
                let bsInviteUser = new bootstrap.Modal($inviteUser.get(0), {
                    keyboard: true
                });
                bsInviteUser.show();

                $inviteUser.find('.btn-modal-confirm').click(function (e) {
                    e.preventDefault();
                    $.ajax({
                        type: 'POST',
                        url: inviteUrl,
                        data: {'_csrf': $('input[name=_csrf]').val(), 'email': $('input[name=email]').val()},
                        statusCode: {
                            201: function () {
                                window.location = editHcGateway;
                            }
                        }
                    }).fail(function (msg) {
                        console.log(msg);
                    }).done(function (msg) {
                        $('#invite-user').find('.modal-body').replaceWith($(msg).find('.modal-body'));
                    })
                });
            });
        });
    }
}

/* ========================================================================
 * initHcGatewayEditForm
 * ========================================================================*/
function initPreventHtml5Validation() {
    // prevent validation
    $('input[type="email"]').on('invalid', function () {
        return false;
    });
    $('input[type="tel"]').on('invalid', function () {
        return false;
    });
}

/* ========================================================================
 * mobileFix
 * ========================================================================*/
function mobileFix() {
    if ($.browser.mobile) {
        if ($('.login-body').length === 0) {
            $("#footer").css("position", "sticky");
        }

        $(window).on("orientationchange", function () {
            $(".bluebar").css("width", "101%");
        });

        if ($.browser.android) {
            let $htmlOrBody = $('html, body');
            let scrollTopPadding = 8;

            $('input').focus(function () {
                let inputTop = $(this).offset().top;
                $htmlOrBody.animate({scrollTop: inputTop - scrollTopPadding}, 250);
            });
        }
    }
}

/* ========================================================================
 * initSupportDialog
 * ========================================================================*/
Number.prototype.pad = function (size) {
    let s = String(this);
    while (s.length < (size || 2)) {
        s = "0" + s;
    }
    return s;
};

function counter($element) {
    let start = new Date().getTime(), time = 0;
    (function loop() {
        let value = $element.attr('data-counter');
        let $supportBtn = $('#support-btn');
        if (value--) {
            $element.find('.minute-value').text(Math.floor(value / 60).pad());
            $element.find('.second-value').text((value % 60).pad());
            $element.attr('data-counter', value);
            time += 1000;
            let diff = (new Date().getTime() - start) - time;
            setTimeout(loop, 1000 - diff);
            $supportBtn.text($supportBtn.attr('data-deactivate'));
        } else {
            $element.find('.minute-value').text(Number(0).pad());
            $element.find('.second-value').text(Number(0).pad());
            $element.attr('data-counter', 0);
            $supportBtn.text($supportBtn.attr('data-activate'));
        }
    })();
}

function initSupportDialog() {
    if ($('.edit-profile').length > 0) {
        $('#support-btn').click(function (e) {
            e.preventDefault();
            let bsDialog = new bootstrap.Modal($('#confirm-support-access').get(0), {
                keyboard: true
            });
            bsDialog.show();
        });

        // Start Countdown
        let $confirmSupportAccess = $('#confirm-support-access');
        counter($confirmSupportAccess);

        $confirmSupportAccess.find('.btn-grant').click(function (e) {
            e.preventDefault();
            $.ajax({
                type: 'POST',
                url: messages.context_path + '/profile/grant_support_access',
                data: {'_csrf': $('input[name=_csrf]').val()},
                dataType: 'json'
            }).fail(function (msg) {
                console.log(msg);
            }).done(function (msg) {
                let countdown = $confirmSupportAccess.attr('data-counter');
                $confirmSupportAccess.attr('data-counter', msg.time + 1);
                if (countdown <= 0) {
                    counter($('#confirm-support-access'));
                }
            });
        });

        $confirmSupportAccess.find('.btn-revoke').click(function (e) {
            e.preventDefault();
            $.ajax({
                type: 'POST',
                url: messages.context_path + '/profile/revoke_support_access',
                data: {'_csrf': $('input[name=_csrf]').val()},
                dataType: 'json'
            }).fail(function (msg) {
                console.log(msg);
            }).done(function (msg) {
                let countdown = $confirmSupportAccess.attr('data-counter');
                $confirmSupportAccess.attr('data-counter', msg.time);
                if (countdown <= 0) {
                    counter($('#confirm-support-access'));
                }
                $confirmSupportAccess.modal('hide');
            });
        });
    }
}

/* ========================================================================
 * check for old browser
 * ========================================================================*/
function initBrowserCheck() {
    let $oldBrowserDialog = $('#old-browser-message');
    if ($oldBrowserDialog.length > 0) {
        if (($.browser.msie && $.browser.versionNumber < 11) ||
            ($.browser.mozilla && $.browser.versionNumber < 31) ||
            ($.browser.chrome && $.browser.versionNumber < 31) ||
            ($.browser.android && $.browser.versionNumber < 4) ||
            ($.browser.safari && $.browser.versionNumber < 7)) {
            let bsOldBrowserDialog = new bootstrap.Modal($oldBrowserDialog.get(0), {
                keyboard: true
            });
            bsOldBrowserDialog.show();
        }
    }
}

/* ========================================================================
 * confirm unknown address dialog
 * ========================================================================*/
function initConfirmUnknownAddress() {
    let $dialog = $('#confirm-unknown-address');
    if ($dialog.length > 0) {
        let $ok = ($dialog.find('.btn-modal-confirm'));
        $ok.attr('data-bs-dismiss', '');
        $ok.click(function (e) {
            e.preventDefault();
            let $input = $('<input type="hidden" name="ignoreValidation"/>').val('true');
            $('form:first').append($input).submit();
        });

        let bsDialog = new bootstrap.Modal($dialog.get(0), {
            keyboard: true
        });
        bsDialog.show();
    }
}

/* ========================================================================
 * inits the why reg dialog
 * ========================================================================*/
function initWhyRegDialog() {
    $('#why-reg').click(function (e) {
        e.preventDefault();
        $('#why-reg-dialog').load(messages.context_path + '/why_reg', function () {
            let $whyRegMessage = $('#why-reg-message');
            let bsWhyRegDialog = new bootstrap.Modal($whyRegMessage.get(0), {
                keyboard: true
            });
            bsWhyRegDialog.show();
        });
    });
}

/* ========================================================================
 * init edit user dialog
 * ========================================================================*/
function initEditAvatarAction() {
    let $editAvatar = $('#edit-avatar');
    if ($editAvatar.length > 0) {
        let $avatarUpload = $('#avatar-upload');
        $avatarUpload.change(function () {
            $(this).parent().submit();
        });

        $editAvatar.click(function (e) {
            e.preventDefault();
            $avatarUpload.trigger('click');
        });
    }
}

/* ========================================================================
 * init dialog focus
 * ========================================================================*/
function initDialogFocus() {
    let $body = $('body');
    $body.on('shown.bs.modal', '.modal', function () {
        let $modal = $(this);
        let $input = $modal.find('input[type=text]:first');

        document.activeElement.blur();
        if (!$.browser.msie && $input.length > 0) {
            if ($input.parent().hasClass('bs-searchbox')) {
                $input.parents('.bootstrap-select').children('.btn').focus();
            } else {
                $input.focus();
            }
        } else {
            $modal.find('.modal-header button').focus();
        }

        $modal.off('keydown.enter.bs.modal');
        $modal.on('keydown.enter.bs.modal', $.proxy(function (e) {
            if (e.which === 13) {
                e.preventDefault();
                $modal.find('.btn-modal-confirm').trigger('click');
                $modal.find('.btn-modal-ok').trigger('click');
            }
        }, this))
    });

    $body.on('hide.bs.modal', '.modal', function () {
        let $modal = $(this);
        $modal.off('keydown.enter.bs.modal');
    })
}

/* ========================================================================
 * init custom sms gateway dialog
 * ========================================================================*/
function toggleTestSmsButton() {
    if ($('#smsGatewaySelection').selectpicker().val() === 'c' &&
        $('#smsGatewayURL').val().length > 0 &&
        $('#smsTestPhoneNumber').val().length > 0) {
        $('#edit-sms-gateway-dialog').find('.btn-test').show();
    } else {
        $('#edit-sms-gateway-dialog').find('.btn-test').hide();
    }
}

function addFormErrors($form, errors) {
    $form.find('.is-invalid').removeClass('is-invalid');
    $form.find('.error-text').remove();

    $.each(errors, function (i, item) {
        console.log(i, item)
        let $errorMsg = $('<div class="invalid-feedback error-text"></div>');
        $errorMsg.text(item.message);
        $form.find('input[name="' + item.field + '"]').addClass('is-invalid').after($errorMsg);
        $form.find('textarea[name="' + item.field + '"]').addClass('is-invalid').after($errorMsg);
        $form.find('select[name="' + item.field + '"]').addClass('is-invalid').parents('.bootstrap-select').addClass('is-invalid').append($errorMsg);
    });
}

function initSmsGatewayDialog() {
    let $dialog = $('#edit-sms-gateway-dialog');
    let $smsGatewaySelection = $('#smsGatewaySelection');
    $smsGatewaySelection.children('option[value=""]').remove();
    initSelect();

    toggleTestSmsButton();
    $smsGatewaySelection.selectpicker().change(function () {
        if ($(this).val() === 'd') {
            $('#sms-gateway-url').hide({'duration': 'slow', 'easing': 'linear'});
            toggleTestSmsButton();
        } else {
            $('#sms-gateway-url').show({'duration': 'slow', 'easing': 'linear'});
            toggleTestSmsButton();
        }
    }).trigger('change');

    $('#smsGatewayURL').keyup(function () {
        toggleTestSmsButton();
    });

    $('#smsTestPhoneNumber').keyup(function () {
        toggleTestSmsButton()
    });

    let $editSmsGatewayForm = $('#edit-sms-gateway-form');
    $editSmsGatewayForm.find('input').change(function () {
        $(this).parents('.form-control').removeClass('is-invalid');
    });

    $dialog.find('.btn-modal-ok').click(function (e) {
        e.preventDefault();
        $.ajax({
            type: 'POST',
            url: $editSmsGatewayForm.attr('action'),
            data: {
                '_csrf': $editSmsGatewayForm.find('input[name=_csrf]').val(),
                'smsGatewaySelection': $editSmsGatewayForm.find('#smsGatewaySelection').selectpicker().val(),
                'smsGatewayURL': $editSmsGatewayForm.find('input[name=smsGatewayURL]').val()
            },
            dataType: 'json'
        }).fail(function (msg) {
            console.log(msg);
        }).done(function (msg) {
            if (msg.success === true) {
                window.location = msg.redirect.substring(9);
            } else {
                addFormErrors($editSmsGatewayForm, msg.errors);
            }
        });
    });

    $dialog.find('.btn-test').click(function (e) {
        e.preventDefault();
        $.ajax({
            type: 'POST',
            url: $(this).data('action'),
            data: {
                '_csrf': $editSmsGatewayForm.find('input[name=_csrf]').val(),
                'smsGatewaySelection': $editSmsGatewayForm.find('#smsGatewaySelection').selectpicker().val(),
                'smsGatewayURL': $editSmsGatewayForm.find('input[name=smsGatewayURL]').val(),
                'smsTestPhoneNumber': $editSmsGatewayForm.find('input[name=smsTestPhoneNumber]').val()
            },
            dataType: 'json'
        }).fail(function (msg) {
            console.log(msg);
        }).done(function (msg) {
            if (msg.success === true) {
                alert(msg.alert);
            } else {
                addFormErrors($editSmsGatewayForm, msg.errors);
            }
        });
    });
}

function initCustomSmsGateway() {
    if ($('.edit-user-body').length > 0) {
        $('#edit-sms-gateway').click(function (e) {
            e.preventDefault();
            $('#edit-sms-gateway-dialog').load(messages.context_path + '/profile/edit_sms_gateway', function () {
                let $editSmsGateway = $('#edit-sms-gateway');
                let bsEditSmsGateway = new bootstrap.Modal($editSmsGateway.get(0), {
                    keyboard: true
                });
                bsEditSmsGateway.show();
                initSmsGatewayDialog();
            });
        });
    }
}

/* ========================================================================
 * init sms token dialog
 * ========================================================================*/
function initSmsToken() {
    let $editSmsTokenDialog = $('#edit-sms-token-dialog');
    if ($editSmsTokenDialog.length > 0) {
        let phoneNumberUuid = $editSmsTokenDialog.data("uuid");
        $editSmsTokenDialog.load(messages.context_path + '/profile/phones/' + phoneNumberUuid + '/sms_token', function () {
            let $editSmsToken = $('#edit-sms-token');
            let bsEditSmsToken = new bootstrap.Modal($editSmsToken.get(0), {
                keyboard: true
            });
            bsEditSmsToken.show();

            $editSmsTokenDialog.find('.btn-modal-ok').click(function (e) {
                e.preventDefault();
                let $form = $('#edit-sms-token-form');
                $.ajax({
                    type: 'POST',
                    url: $form.attr('action') + phoneNumberUuid + '/sms_token',
                    data: {
                        '_csrf': $form.find('input[name=_csrf]').val(),
                        'smsToken': $form.find('input[name=smsToken]').val()
                    },
                    dataType: 'json'
                }).fail(function (msg) {
                    console.log(msg);
                }).done(function (msg) {
                    if (msg.success === true) {
                        window.location = msg.redirect.substring(9);
                    } else {
                        addFormErrors($form, msg.errors);
                    }
                });
            });

            $editSmsTokenDialog.find('.btn-resend').click(function (e) {
                e.preventDefault();
                let $form = $('#edit-sms-token-form');
                $.ajax({
                    type: 'POST',
                    url: $form.attr('action') + phoneNumberUuid + '/sms_token/resend',
                    data: {
                        '_csrf': $form.find('input[name=_csrf]').val()
                    },
                    dataType: 'json'
                }).fail(function (msg) {
                    console.log(msg);
                }).done(function (msg) {
                    if (msg.success === false) {
                        addFormErrors($form, msg.errors);
                    }
                });
            });
        });
    }
}

/* ========================================================================
 * init edit messages
 * ========================================================================*/
function initEditMessages() {
    if ($('.admin-edit-messages-body').length > 0) {
        let $iconClass = $('#iconClass');
        $iconClass.change(function () {
            let val = $(this).val();
            if (val && val.length > 0) {
                $('#icon-class').removeClass().addClass('bi-icons').addClass(val);
            } else {
                $('#icon-class').removeClass().addClass('bi-icons');
            }
        });

        let $textClass = $('#textClass');
        $textClass.change(function () {
            $('#text-class').removeClass().addClass($(this).val());
        });

        $iconClass.trigger('change');
        $textClass.trigger('change');
    }
}

/* ========================================================================
 * init learn mode
 * ========================================================================*/
function learnModeError() {
    removeAjaxOverlay();
    setTimeout(function () {
        let $learnModeErrorDialog = $('#learn-mode-error-dialog');
        let bsLearnModeErrorDialog = new bootstrap.Modal($learnModeErrorDialog.get(0), {
            keyboard: true
        });
        bsLearnModeErrorDialog.show();
    }, 1300);
}

function learnModeSuccess() {
    removeAjaxOverlay();
    setTimeout(function () {
        let $learnModeSuccessDialog = $('#learn-mode-success-dialog');
        let bsLearnModeSuccessDialog = new bootstrap.Modal($learnModeSuccessDialog.get(0), {
            keyboard: true
        });
        bsLearnModeSuccessDialog.show();
    }, 1300);
}

function setLearnModeCheckPending(url) {
    setTimeout(function () {
        learnModeCheckPending(url);
    }, 10000);
}

function learnModeCheckPending(url) {
    $.ajax({
        type: 'GET',
        url: url
    }).fail(function (msg) {
        learnModeError(msg)
    }).done(function (msg) {
        if (msg.status === 1) {
            setLearnModeCheckPending(url);
        } else if (msg.status === 3) {
            learnModeError(msg);
        } else {
            learnModeSuccess()
        }
    });
}

function initLearnMode() {
    if ($('.edit-gateway-body').length > 0) {
        $('#learn-mode-btn').click(function (e) {
            let url = $(this).data('action');
            e.preventDefault();
            addAjaxOverlay();
            $.ajax({
                type: 'POST',
                url: url,
                data: {'_csrf': $('input[name=_csrf]').val()}
            }).fail(function (msg) {
                learnModeError(msg);
            }).done(function (msg) {
                if (msg.status === 1) {
                    setLearnModeCheckPending(url + "/pending");
                } else if (msg.status === 3) {
                    learnModeError(msg);
                } else {
                    learnModeSuccess()
                }
            })
        })
    }
}

/* ========================================================================
 * document init
 * ========================================================================*/
$(function () {
    if (!$.browser.mobile) {
        initDialogFocus();
    }

    initExternalLinks();
    initCheckBox();
    initSwitchCheckBox();
    initSelect();
    initDateSelect();
    initDateChange();
    initPasswordStrengthBar();
    initActionDelete();
    initFlyout();
    initUserAddressForm();
    initSimpleSlider();
    initLanguageSelect();
    initLoaderSubmit();
    initHcGatewayEditForm();
    initSupportDialog();
    initEditAvatarAction();
    initCustomSmsGateway();
    initSmsToken();

    clearErrorsOnChange();
    initDashboardEditForm();

    let $modalMessage = $('#modalMessage');
    if ($modalMessage.length !== 0) {
        let bsModalMessage = new bootstrap.Modal($modalMessage.get(0), {
            keyboard: true
        });
        bsModalMessage.show();
    }

    let $modalAutoShow = $('.modal.autoshow');
    if ($modalAutoShow.length !== 0) {
        let bsModalAutoShow = new bootstrap.Modal($modalAutoShow.get(0), {
            keyboard: true
        });
        bsModalAutoShow.show();
    }

    initPreventHtml5Validation();
    mobileFix();
    initBrowserCheck();
    initConfirmUnknownAddress();
    initWhyRegDialog();
    initEditMessages();
    initLearnMode();
});
